import React from 'react';
import { THEMES } from '@americanexpress/consumer-travel-base';

const themeContext = React.createContext(THEMES.THEME_BLUE);

export default themeContext;
